module.exports = __webpack_public_path__ + "static/media/marketplace-product-img-2.0d5ef2e0.svg";